// extracted by mini-css-extract-plugin
export default {"WelcomeContainer":"Welcome_WelcomeContainer__sDuuz","WelcomeInfo":"Welcome_WelcomeInfo__N+DXu","actionBtn":"Welcome_actionBtn__o20e0"};